var bsv = require('../../')
bsv.Message = require('./message')

module.exports = bsv.Message
